export default "__VITE_ASSET__C6prgz$6__"